import { render } from "./Widget5.vue?vue&type=template&id=9d472b16"
import script from "./Widget5.vue?vue&type=script&lang=js"
export * from "./Widget5.vue?vue&type=script&lang=js"
script.render = render

export default script